// Daten für „Objekt verknüpfen“ (Panel Objekte & Rollen): alle Objekte zur Suche und – für das
// gewählte Objekt – Einheiten und Eigentum (wie im Formular „Neuer Eigentümer“).

import { supabase } from '../supabase/client';
import { alleSeiten } from '../supabase/alleSeiten';
import type { EigentumsDaten } from './neuerEigentuemer';
import type { EigentuemerRoh, EinheitEigRoh, EinheitRoh, ObjektEigRoh, ObjektRoh } from './liste';

export async function ladeObjekteZurAuswahl(): Promise<ObjektRoh[]> {
  return alleSeiten<ObjektRoh>((von, bis) => supabase.from('objekte')
    .select('*').order('objektnummer').range(von, bis));
}

type MitEig<T> = T & { eigentuemer: EigentuemerRoh | null };

export async function ladeEigentumImObjekt(objektId: string): Promise<EigentumsDaten> {
  const einheiten = (await supabase.from('objekt_einheiten').select('id, objekt_id, bezeichnung, wohnflaeche').eq('objekt_id', objektId)).data as EinheitRoh[] | null ?? [];
  const [oe, ee] = await Promise.all([
    supabase.from('objekt_eigentuemer').select('objekt_id, eigentuemer_id, vertrag_ab, vertrag_bis, eigentuemer:eigentuemer_id(id, anrede, vorname, nachname, firma_name)').eq('objekt_id', objektId),
    einheiten.length
      ? supabase.from('einheit_eigentuemer')
        .select('einheit_id, eigentuemer_id, mea, hausgeld_vorschuss, ruecklage_vorschuss, sev_status, vertrag_ab, vertrag_bis, eigentuemer:eigentuemer_id(id, anrede, vorname, nachname, firma_name)')
        .in('einheit_id', einheiten.map(e => e.id))
      : Promise.resolve({ data: [], error: null }),
  ]);
  if (oe.error) throw new Error(oe.error.message);
  if (ee.error) throw new Error(ee.error.message);
  const objektEig = (oe.data ?? []) as unknown as MitEig<ObjektEigRoh>[];
  const einheitEig = (ee.data ?? []) as unknown as MitEig<EinheitEigRoh>[];
  const eigentuemer = new Map<string, EigentuemerRoh>();
  for (const r of [...objektEig, ...einheitEig]) if (r.eigentuemer) eigentuemer.set(r.eigentuemer_id, { ...r.eigentuemer, id: r.eigentuemer_id });
  return { eigentuemer: [...eigentuemer.values()], objektEig, einheitEig, einheiten };
}
